export const QA_NAME_MODAL_EXPORT_TABLE = 'ExportData'

export const EXPORT_TABLE_FORM_FIELD_SELECT_ALL = 'selectAll'

export const INITIAL_VALUES = {
  [EXPORT_TABLE_FORM_FIELD_SELECT_ALL]: true,
}
